import { useRef } from 'react';

import { AppointmentAdvancePaymentSendOnlinePaymentLinkToPatientCommand } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';
import { PhoneNumber } from '@dreryk/phone-number-common-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import {
   AdvancePaymentSettlementFormBean,
   AdvancePaymentSettlementFormController,
} from './AdvancePaymentSettlementForm.types';

type AdvancePaymentShareOnlinePaymentLinkToPatientActionEventInterceptorProps = Readonly<
   Pick<AdvancePaymentSettlementFormController, 'handleSubmit'> & {
      onlinePaymentId: string;
      children: JSX.Element;
   }
>;

export const AdvancePaymentShareOnlinePaymentLinkToPatientActionEventInterceptor = (
   props: AdvancePaymentShareOnlinePaymentLinkToPatientActionEventInterceptorProps
): JSX.Element => {
   const phoneNumberRef = useRef<PhoneNumber | null>(null);
   const { executeAsync: shareOnlinePaymentLinkToPatient } = useCqrsCommand<string, AdvancePaymentSettlementFormBean>(
      (parameters) => {
         const command = new AppointmentAdvancePaymentSendOnlinePaymentLinkToPatientCommand();
         command.onlinePaymentId = props.onlinePaymentId;
         command.patientPhoneNumber = parameters.patientPhoneNumber!;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(translationKeys.smsLinkSendRequested);
         },
      }
   );

   const handleAction = props.handleSubmit(async (formData) => {
      phoneNumberRef.current = formData.patientPhoneNumber;
      return shareOnlinePaymentLinkToPatient(formData);
   });

   return <ActionEventInterceptor action={handleAction}>{props.children}</ActionEventInterceptor>;
};
